"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "client-preview" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("label", { for: "" }, "Chosir l'entreprise"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("select", {
        name: "enterprise_id",
        id: "enterprise_id",
        placeholder: "Raison sociale, nom..."
    })
], -1);
var _hoisted_3 = [
    _hoisted_2
];
var tom_select_1 = __importDefault(require("tom-select"));
var vue_3 = require("vue");
var models_1 = require("../models");
exports.default = (0, vue_1.defineComponent)({
    name: 'CompanySelector',
    props: {
        enterprise: {
            type: models_1.Enterprise,
            required: false
        },
        preload: {
            type: Boolean,
            default: false
        }
    },
    emits: ['selected'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        (0, vue_3.onMounted)(function () {
            new tom_select_1.default('#enterprise_id', {
                create: false,
                items: props.enterprise ? [props.enterprise.id.toString()] : [],
                options: props.enterprise ? [props.enterprise] : [],
                maxItems: 1,
                closeAfterSelect: true,
                valueField: 'id',
                labelField: 'summer',
                searchField: ['title', 'firstname', 'lastname'],
                preload: props.preload,
                load: function (q, callback) {
                    globalThis.axios.get('/api/enterprises', { params: { q: q } })
                        .then(function (resp) {
                        var data = resp.data.map(function (item) { return new models_1.Enterprise(item); });
                        callback(data, []);
                    })
                        .catch(function () {
                        callback([], []);
                    });
                },
                onItemAdd: function (value) {
                    emit('selected', value);
                }
            });
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, _hoisted_3));
        };
    }
});
